module.exports = __webpack_public_path__ + "img/x-white.824c8f95.svg";